import { getUrlQueryParamsObj } from '~utils/helpers'

export type UrlQueryParamInput = {
    newSearch?: string
    newClient?: string
    newPatient?: string
    newAppointment?: string
    newDate?: Date | 'erase'
    newPage?: number
    newPageSize?: number
    newNotificationTemplateIds?: string[]
    newPreviewClinic?: string | 'erase'
}

export function getCleanedQueryParams(): {
    search?: string
    client?: string
    patient?: string
    appointment?: string
    date?: Date
    page?: number
    pageSize?: number
    dataChat?: string
    notificationTemplateIds?: string[]
    chatId?: string
    previewClinic?: string
} {
    const {
        search: parsedSearch,
        client: parsedClient,
        patient: parsedPatient,
        appointment: parsedAppointment,
        page: parsedPage,
        pageSize: parsedPageSize,
        date: parsedDate,
        dataChat: parsedDataChat,
        notificationTemplateIds: parsedNotificationTemplateIds,
        chatId: parsedChatId,
        previewClinic: parsedPreviewClinic,
    } = getUrlQueryParamsObj()

    const search = typeof parsedSearch === 'string' ? parsedSearch : undefined
    const client = typeof parsedClient === 'string' ? parsedClient : undefined
    const patient =
        typeof parsedPatient === 'string' ? parsedPatient : undefined
    const appointment =
        typeof parsedAppointment === 'string' ? parsedAppointment : undefined
    const page =
        typeof parsedPage === 'string' ? parseInt(parsedPage) : undefined
    const pageSize =
        typeof parsedPageSize === 'string'
            ? parseInt(parsedPageSize)
            : undefined
    const date =
        typeof parsedDate === 'string' ? new Date(parsedDate) : undefined
    const dataChat =
        typeof parsedDataChat === 'string' ? parsedDataChat : undefined
    const notificationTemplateIds =
        typeof parsedNotificationTemplateIds === 'string'
            ? parsedNotificationTemplateIds.split(',')
            : undefined
    const chatId = typeof parsedChatId === 'string' ? parsedChatId : undefined
    const previewClinic =
        typeof parsedPreviewClinic === 'string'
            ? parsedPreviewClinic
            : undefined

    return {
        search,
        client,
        patient,
        appointment,
        date,
        page,
        pageSize,
        dataChat,
        notificationTemplateIds,
        chatId,
        previewClinic,
    }
}
